<template>
  <div class="order-review py20">
    <div class="row" v-if="isActive || isFilled">
      <div class="col-xs-2 col-sm-2 col-md-1">
        <div
          class="number-circle lh35 cl-white brdr-circle align-center weight-700"
          :class="{ 'bg-cl-th-accent' : isActive || isFilled, 'bg-cl-tertiary' : !isFilled && !isActive }"
        >
          7
        </div>
      </div>
      <div class="col-xs-8 col-sm-8 col-md-10">
        <div class="row">
          <div class="col-md-12" :class="{ 'cl-bg-tertiary' : !isFilled && !isActive }">
            <h3 class="m0">
              {{ $t('Review order') }}
            </h3>
          </div>
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-1 end-xs">
            <i data-v-0c2f6ec6="" class="material-icons arrow-i"
               :class="{ 'active' : isActive }"
            >keyboard_arrow_right</i>
        </div>
    </div>
    <div class="row mt15" v-show="isActive">
      <div class="col-xs-12">
        <div id="checkout-order-review-additional-container">
          <div id="checkout-order-review-additional" />
        </div>
        <div class="row mb15 mt10">
          <div class="col-xs-12">
            <p class="h4 green-color">
              {{ $t('Please check if all data are correct') }}
            </p>
            <div class="row">
                <pickup-summary :user-info="userInfo"
                         :shipping="shipping"
                         :pickup-address="pickupAddress"
                         :pickup-target="pickupTarget"
                         :delivery-time="deliveryTime"
                         :payment="payment"
                         :delivery-price="deliveryPrice"
                />

              <base-checkbox
                class="col-xs-12 bg-cl-secondary p15 mb5"
                id="contact-to-replace-checkbox"
                :disabled="true"
                :value="true"
                v-if="currentLocation.code !== 'lutsk'"
              >
                {{ $t('Call me') }}
              </base-checkbox>
              <base-checkbox
                class="col-xs-12 bg-cl-secondary p15 mb5"
                id="acceptTermsCheckbox"
                v-model="orderReview.terms"
                :validations="[{
                  condition: !$v.orderReview.terms.required && $v.orderReview.terms.$error,
                  text: $t('Field is required')
                }]"
              >
                {{ $t('I agree to') }}
                <span
                  class="link pointer"
                  @click.prevent="openModal"
                >
                  {{ $t('Terms and conditions') }}
                </span>
              </base-checkbox>
              <div class="col-xs-12 bg-cl-secondary p15 mb35 pointer" >
                <span @click.prevent="openModalDelivery" class="text-delivery">{{ $t('Terms and cost of delivery') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-show="isActive">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12 col-md-8" style="margin: auto">
            <slot name="placeOrderButton">
              <button-full
                @click.native="placeOrder($event)"
                data-testid="orderReviewSubmit"
                class="place-order-btn"
                :disabled="$v.orderReview.$invalid || isDeliveryPriceUnknown"
              >
                {{ $t('Place the order') }}
              </button-full>
              <div v-if="isDeliveryPriceUnknown" class="align-center mt10">
                <p class="h5 bold cl-error">{{ $t('Could not calculate the delivery price') }}</p>
                <mini-button-full :disabled="isRetrying" @click.native="retryDeliveryPrice">
                  {{ $t('Try again') }}
                </mini-button-full>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <modal-terms-of-use :showModal="showModal"/>
    <delivery-modal :showModalDelivery="showModalDelivery"/>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import BaseCheckbox from 'theme/components/core/blocks/Form/BaseCheckbox'
import ButtonFull from 'theme/components/theme/ButtonFull'
import MiniButtonFull from 'theme/components/theme/MiniButtonFull'
import PickupSummary from 'theme/components/theme/blocks/PickupCheckout/PickupSummary'
import Modal from 'theme/components/core/Modal'
import ModalTermsOfUse from "../../../core/blocks/Checkout/ModalTermsOfUse";
import DeliveryModal from "./DeliveryModal";
import { mapGetters } from 'vuex'

export default {
  components: {
    BaseCheckbox,
    ButtonFull,
    MiniButtonFull,
    PickupSummary,
    Modal,
    ModalTermsOfUse,
    DeliveryModal
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    userInfo: {
      type: Object,
      required: false
    },
    shipping: {
      type: Object,
      required: false
    },
    pickupAddress: {
      type: Object,
      required: false
    },
    pickupTarget: {
      type: String,
      required: false
    },
    deliveryTime: {
      type: Object,
      required: false
    },
    payment: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      isFilled: false,
      orderReview: {
        terms: false,
        contactToReplace: true
      },
      showModalDelivery: false,
      showModal: false,
      isRetrying: false
    }
  },
  validations: {
    orderReview: {
      terms: {
        required
      }
    }
  },
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation'
    }),
    deliveryPrice () {
      const price = parseFloat(this.currentLocation && this.currentLocation.call_courier_price)
      return isNaN(price) ? null : price
    },
    isDeliveryPriceUnknown () {
      return this.deliveryPrice == null
    }
  },
  methods: {
    onSuccess () {
    },
    async retryDeliveryPrice () {
      this.isRetrying = true
      try {
        const locations = await this.$store.dispatch('locations/loadLocations')
        const location = locations.find(({ code }) => code === this.$route.params.locationCode)
        if (location) this.$store.commit('locations/locations/SET_CURRENT_LOCATION', location)
      } finally {
        this.isRetrying = false
      }
    },
    openModalDelivery () {
      this.$bus.$emit('modal-toggle', 'modal-delivery');
      this.showModalDelivery = true;
    },
    openModal () {
      this.$bus.$emit('modal-toggle', 'modal-terms');
      this.showModal = true;
    },
    onFailure (result) {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message: this.$t(result.result),
        action1: { label: this.$t('OK') }
      })
    },
    placeOrder (event, comment) {
      let comments = JSON.parse(localStorage.getItem('shop/anywhere/comment'));
      if (comments && comments.length > 1) {
        let otherComment = []
        comments.map(comment => {
          if (comment.location !== this.currentLocation.code) {
            otherComment.push(comment)
          }
        })
        localStorage.setItem('shop/anywhere/comment', JSON.stringify(otherComment))
      } else {
        localStorage.removeItem('shop/anywhere/comment')
      }
      this.$bus.$emit('pickup-checkout-after-orderReview', this.orderReview)
      this.$bus.$emit('pickup-checkout-do-placeOrder')
    }
  }
}
</script>

<style lang="scss" scoped>
  .link {
    text-decoration: underline;
  }

  .textarea-box {
    margin-left: 5px;
  }
    .green-color{
        color: #11bb2e;
    }
  .text-delivery{
    font-size: 14px;
    text-decoration: underline;
  }
</style>
